<div class="manual-reservation-wrapper edit-reservation-wrapper">
  <!-- defaultplus tenants: appointment edit form (service catalog, slots) -->
  @if (isDefaultPlus) {
  <app-edit-appointment [ticketContext]="ticketContext"></app-edit-appointment>
  }

  <!-- restaurant / default tenants: the table-reservation edit flow -->
  @if (!isDefaultPlus) { @if (isLoading) {
  <div
    class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-overlay"
  >
    <div class="spinner-border" role="status" aria-hidden="true"></div>
  </div>
  }
  <!-- Guest editing switched off by the tenant: polite dead-end, no form. -->
  @if (guestEditDisabled) {
  <c-card class="modern-card">
    <div class="header-minimal">
      <span class="eyebrow text-uppercase">
        {{ "EDIT_RESERVATION.DISABLED_TITLE" | translate }}
      </span>
      <h2 class="company-name mb-0">
        {{ companyName || "Sagel" }}
      </h2>
      <span class="header-date reservation-id">
        {{ "CANCEL_PAGE.RESERVATION_NUMBER" | translate }}:
        <strong>{{ reservationId }}</strong>
      </span>
    </div>
    <c-card-body class="body-content">
      <p class="mb-3">{{ "EDIT_RESERVATION.DISABLED_TEXT" | translate }}</p>
      @if (disabledMessage) {
      <p class="mb-0">
        <em>{{ disabledMessage }}</em>
      </p>
      }
    </c-card-body>
  </c-card>
  } @if (pastReservation && !guestEditDisabled) {
  <c-card class="modern-card">
    <div class="header-minimal">
      <span class="eyebrow text-uppercase">
        {{ "EDIT_RESERVATION.PAST_TITLE" | translate }}
      </span>
      <h2 class="company-name mb-0">
        {{ companyName || "Sagel" }}
      </h2>
      <span class="header-date reservation-id">
        {{ "CANCEL_PAGE.RESERVATION_NUMBER" | translate }}:
        <strong>{{ reservationId }}</strong>
      </span>
    </div>
    <c-card-body class="body-content past-reservation-state">
      <div class="past-reservation-state__icon" aria-hidden="true">
        <svg [cIcon]="icons.cilWarning" size="xxl"></svg>
      </div>
      <h3>{{ "EDIT_RESERVATION.PAST_TITLE" | translate }}</h3>
      <p>{{ "EDIT_RESERVATION.PAST_TEXT" | translate }}</p>
    </c-card-body>
  </c-card>
  } @if (success !== true && !guestEditDisabled && !pastReservation) {
  <c-card class="modern-card">
    <div class="header-minimal">
      <span class="eyebrow text-uppercase">
        {{ "EDIT_RESERVATION.EDIT_TITLE" | translate }}
      </span>
      <h2 class="company-name mb-0">
        {{ companyName || "Sagel" }}
      </h2>
      <span class="header-date reservation-id">
        {{ "CANCEL_PAGE.RESERVATION_NUMBER" | translate }}:
        <strong>{{ reservationId }}</strong>
      </span>
    </div>
    <c-card-body class="body-content">
      <form
        #form="ngForm"
        (ngSubmit)="saveChanges(form)"
        novalidate
        class="modern-form"
      >
        <div class="step-progress">
          <button
            type="button"
            class="step-pill"
            [ngClass]="{
              active: currentStep === 1,
              complete: isStepOneValid()
            }"
            (click)="goToStep(1)"
          >
            <span class="step-number">1</span>
            <span class="step-label">{{
              "EDIT_RESERVATION.STEP_DETAILS" | translate
            }}</span>
          </button>
          <button
            type="button"
            class="step-pill"
            [ngClass]="{
              active: currentStep === 2,
              complete: isStepTwoValid()
            }"
            [disabled]="!canAccessStep(2)"
            (click)="goToStep(2)"
          >
            <span class="step-number">2</span>
            <span class="step-label">{{
              "EDIT_RESERVATION.STEP_SESSION_TIME" | translate
            }}</span>
          </button>
          <button
            type="button"
            class="step-pill"
            [ngClass]="{
              active: currentStep === 3,
              complete: isStepThreeValid()
            }"
            [disabled]="!canAccessStep(3)"
            (click)="goToStep(3)"
          >
            <span class="step-number">3</span>
            <span class="step-label">{{
              "EDIT_RESERVATION.STEP_CONTACT" | translate
            }}</span>
          </button>
        </div>
        <div class="step-note mb-3">
          {{
            "EDIT_RESERVATION.STEP_INDICATOR"
              | translate : { current: currentStep, total: totalSteps }
          }}
        </div>
        @if (stepValidationMessage) {
        <div class="step-error mb-3">{{ stepValidationMessage }}</div>
        } @if (currentStep === 1) {
        <div class="step-panel">
          <div class="row g-3 g-md-4">
            <div class="col-12 col-md-6">
              <label class="form-label">
                <i class="cil-calendar me-2"></i>
                {{ "EDIT_RESERVATION.START_DATE" | translate }}
              </label>
              <c-date-picker
                closeOnSelect
                [(ngModel)]="date"
                (ngModelChange)="onDateChange($event)"
                locale="en-GB"
                format="dd/MM/yyyy"
                name="startDate"
                [disabledDates]="fullyClosedDates"
                [dateFilter]="dateFilter"
                [minDate]="today"
                required
              ></c-date-picker>
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label">
                <i class="cil-building me-2"></i>
                {{ "EDIT_RESERVATION.SALON" | translate }}
              </label>
              <select
                class="form-select"
                [(ngModel)]="selectedSalon"
                (ngModelChange)="onSalonChange($event)"
                name="salon"
                required
              >
                <option value="" disabled>
                  {{ "EDIT_RESERVATION.SELECT_SALON_PLACEHOLDER" | translate }}
                </option>
                @for (s of salonList; track trackBySalonName($index, s)) {
                <option [value]="s.salon_name">{{ s.salon_name }}</option>
                }
              </select>
            </div>
          </div>
          <div class="row g-3 g-md-4 mt-1 mt-md-3">
            <div class="col-12 col-md-6">
              <label class="form-label">
                <i class="cil-people me-2"></i>
                {{ "EDIT_RESERVATION.NUM_PEOPLE" | translate }}
              </label>
              <input
                type="number"
                min="1"
                step="1"
                class="form-control"
                [(ngModel)]="num_people"
                (ngModelChange)="onPeopleChange()"
                name="numPeople"
                inputmode="numeric"
                required
              />
              @if (partySizeExceeded) {
              <div class="text-danger mt-2">
                {{ partySizeLimitMessage() }}
              </div>
              }
            </div>
            @if (guards.length > 0) {
            <div class="col-12">
              <div class="guard-consent-box">
                <label class="form-label">
                  <i class="cil-shield-alt me-2"></i>
                  {{ "EDIT_RESERVATION.GUARDS_TITLE" | translate }}
                </label>
                @for (guard of guards; track guard) {
                <div class="form-check guard-consent-item">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="edit-guard-consent-{{ guard.id }}"
                    [checked]="guardConsents[guard.id] === true"
                    (change)="toggleGuardConsent(guard)"
                  />
                  <label
                    class="form-check-label"
                    for="edit-guard-consent-{{ guard.id }}"
                  >
                    {{ guard.text }}
                  </label>
                </div>
                }
              </div>
            </div>
            }
          </div>
        </div>
        } @if (currentStep === 2) {
        <div class="step-panel">
          <div class="row g-3 g-md-4 mt-1 mt-md-3">
            <div class="col-12">
              <label class="form-label">
                <i class="cil-calendar me-2"></i>
                {{ "EDIT_RESERVATION.SELECT_SESSION" | translate }}
              </label>
              <div class="session-cards">
                @for (s of sessions; track s) {
                <button
                  type="button"
                  class="session-card"
                  [class.session-card--selected]="selectedSessionId === s.id"
                  [class.session-card--closed]="isSessionClosed(s)"
                  [disabled]="isSessionClosed(s)"
                  (click)="selectSession(s)"
                >
                  <div class="session-card__top">
                    <span class="session-card__name">{{ s.name }}</span>
                  </div>
                  <span class="session-card__time"
                    >{{ s.start_time }} – {{ s.end_time }}</span
                  >
                  @if (isSessionClosed(s)) {
                  <span class="session-card__meta session-card__meta--closed">
                    {{ "EDIT_RESERVATION.UNAVAILABLE" | translate }}
                  </span>
                  }
                </button>
                }
              </div>
              <input
                type="hidden"
                [(ngModel)]="selectedSessionId"
                name="sessionId"
                required
              />
            </div>
            <div class="col-12">
              <label class="form-label">
                <i class="cil-clock me-2"></i>
                {{ "EDIT_RESERVATION.START_TIME" | translate }}
              </label>
              <input
                type="hidden"
                [(ngModel)]="time"
                name="startTime"
                required
              />
              @if (availableTimes.length) {
              <div class="time-slot-picker">
                @for (t of availableTimes; track t) {
                <button
                  type="button"
                  class="time-slot"
                  [class.time-slot--selected]="time === t"
                  (click)="selectStartTime(t)"
                >
                  {{ t }}
                </button>
                }
              </div>
              } @else {
              <div class="time-slot-empty">
                {{ "EDIT_RESERVATION.NO_TIME_SLOTS" | translate }}
              </div>
              }
            </div>
            @if (guestTableSelectionEnabled) {
            <div class="col-12">
              <div class="table-selection">
                <div class="table-selection__header">
                  <div>
                    <h6>
                      {{ "EDIT_RESERVATION.TABLE_SELECTION_TITLE" | translate }}
                    </h6>
                    <p>
                      {{
                        "EDIT_RESERVATION.TABLE_SELECTION_HINT"
                          | translate : { count: num_people || 0 }
                      }}
                    </p>
                  </div>
                  @if (selectedTableId) {
                  <button
                    type="button"
                    class="table-selection__clear"
                    (click)="clearTableSelection()"
                  >
                    {{ "EDIT_RESERVATION.CLEAR_TABLE" | translate }}
                  </button>
                  }
                </div>
                @if (isTableAvailabilityLoading) {
                <div class="table-selection__loading">
                  <span
                    class="spinner-border spinner-border-sm"
                    aria-hidden="true"
                  ></span>
                  {{ "EDIT_RESERVATION.TABLE_LOADING" | translate }}
                </div>
                } @if (!isTableAvailabilityLoading &&
                tableAvailabilityMessageKey) {
                <p class="table-selection__message">
                  {{ tableAvailabilityMessageKey | translate }}
                </p>
                } @if (!isTableAvailabilityLoading &&
                !tableAvailabilityMessageKey) {
                <div class="table-selection__grid">
                  @for (dot of tableAvailabilityDots; track dot) {
                  <button
                    type="button"
                    class="table-option"
                    [class.table-option--selected]="
                      selectedTableId === dot.tableId
                    "
                    [class.table-option--occupied]="!dot.isAvailable"
                    [class.table-option--too-small]="
                      dot.isAvailable && !dot.canFitParty
                    "
                    [class.table-option--too-large]="
                      dot.isAvailable && dot.canFitParty && !dot.isNearestFit
                    "
                    [disabled]="!dot.isAvailable || !dot.isNearestFit"
                    (click)="onTableAvailabilityBoxClick(dot)"
                  >
                    @if (dot.isCombined) {
                    <strong>
                      {{
                        "EDIT_RESERVATION.JOINED_TABLE_LABEL"
                          | translate : { index: dot.joinedTableIndex || 1 }
                      }}
                    </strong>
                    } @else {
                    <strong>{{
                      "Calendar_Page.TABLE_AVAILABILITY_LABEL"
                        | translate : { tableId: dot.tableId }
                    }}</strong>
                    }
                    <small>
                      {{
                        "EDIT_RESERVATION.TABLE_CAPACITY"
                          | translate : { capacity: dot.capacity || 0 }
                      }}
                    </small>
                    @if (!dot.isAvailable) {
                    <span>
                      {{
                        "Calendar_Page.TABLE_AVAILABILITY_LEGEND_OCCUPIED"
                          | translate
                      }}
                    </span>
                    } @if (dot.isAvailable && !dot.canFitParty) {
                    <span>
                      {{ "EDIT_RESERVATION.TABLE_TOO_SMALL" | translate }}
                    </span>
                    } @if (dot.isAvailable && dot.canFitParty &&
                    !dot.isNearestFit) {
                    <span>
                      {{ "EDIT_RESERVATION.TABLE_TOO_LARGE" | translate }}
                    </span>
                    } @if (dot.isAvailable && dot.isNearestFit) {
                    <span>
                      {{
                        "Calendar_Page.TABLE_AVAILABILITY_LEGEND_AVAILABLE"
                          | translate
                      }}
                    </span>
                    }
                  </button>
                  }
                </div>
                }
              </div>
            </div>
            }
          </div>
        </div>
        } @if (currentStep === 3) {
        <div class="step-panel">
          <div class="row g-3 g-md-4 mt-1 mt-md-3">
            <div class="col-12 col-md-6">
              <label class="form-label">
                <i class="cil-user me-2"></i>
                {{ "EDIT_RESERVATION.NAME" | translate }}
              </label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="name"
                name="name"
                autocomplete="name"
                inputmode="text"
                required
                maxlength="80"
              />
            </div>
            <div
              class="col-12 col-md-6 contact-field"
              [class.contact-field--invalid]="
                phoneField.invalid && (phoneField.touched || form.submitted)
              "
            >
              <label class="form-label required">
                <i class="cil-phone me-2"></i>
                {{ "EDIT_RESERVATION.PHONE_NUMBER" | translate }}
                <span class="text-danger">*</span>
              </label>
              <input
                type="tel"
                class="form-control"
                placeholder="{{
                  'EDIT_RESERVATION.PHONE_PLACEHOLDER' | translate
                }}"
                [(ngModel)]="phoneNumber"
                name="phoneNumber"
                #phoneField="ngModel"
                (ngModelChange)="stepValidationMessage = ''"
                autocomplete="tel"
                inputmode="tel"
                pattern="[0-9+() -]{7,20}"
                maxlength="20"
                [class.is-invalid]="
                  phoneField.invalid && (phoneField.touched || form.submitted)
                "
                [attr.aria-invalid]="
                  phoneField.invalid && (phoneField.touched || form.submitted)
                "
                aria-describedby="edit-phone-error"
                required
              />
              @if (phoneField.invalid && (phoneField.touched || form.submitted))
              {
              <small id="edit-phone-error" class="invalid-feedback">
                {{ "EDIT_RESERVATION.PHONE_REQUIRED" | translate }}
              </small>
              }
            </div>
            <div
              class="col-12 col-md-6 contact-field"
              [class.contact-field--invalid]="
                emailField.invalid && (emailField.touched || form.submitted)
              "
            >
              <label class="form-label required">
                <i class="cil-envelope me-2"></i>
                {{ "EDIT_RESERVATION.EMAIL" | translate }}
                <span class="text-danger">*</span>
              </label>
              <input
                type="email"
                class="form-control"
                [(ngModel)]="email"
                name="email"
                #emailField="ngModel"
                autocomplete="email"
                inputmode="email"
                spellcheck="false"
                required
                maxlength="120"
                (ngModelChange)="stepValidationMessage = ''"
                [class.is-invalid]="
                  emailField.invalid && (emailField.touched || form.submitted)
                "
                [attr.aria-invalid]="
                  emailField.invalid && (emailField.touched || form.submitted)
                "
                aria-describedby="edit-email-hint edit-email-error"
              />
              @if (emailField.invalid && (emailField.touched || form.submitted))
              {
              <small id="edit-email-error" class="invalid-feedback">
                {{ "EDIT_RESERVATION.EMAIL_REQUIRED" | translate }}
              </small>
              }
              <small id="edit-email-hint" class="text-muted d-block">
                {{ "EDIT_RESERVATION.EMAIL_REQUIRED_HINT" | translate }}
              </small>
            </div>
            <div class="col-12">
              <label class="form-label">
                <i class="cil-notes me-2"></i>
                {{ "EDIT_RESERVATION.NOTES" | translate }}
                <span class="label-optional">{{
                  "EDIT_RESERVATION.OPTIONAL" | translate
                }}</span>
              </label>
              <textarea
                class="form-control"
                rows="3"
                maxlength="500"
                [(ngModel)]="service"
                name="service"
                placeholder="{{
                  'EDIT_RESERVATION.NOTES_PLACEHOLDER' | translate
                }}"
              ></textarea>
            </div>
            <div class="col-12">
              <app-altcha
                action="update_reservation"
                (tokenChange)="captchaToken = $event"
                (readyChange)="captchaReady = $event"
              ></app-altcha>
            </div>
          </div>
        </div>
        }
        <div class="step-actions">
          <button
            cButton
            type="button"
            class="btn-nav-modern"
            [disabled]="currentStep === 1"
            (click)="prevStep()"
          >
            {{ "EDIT_RESERVATION.BACK" | translate }}
          </button>
          @if (currentStep < totalSteps) {
          <button
            cButton
            type="button"
            class="btn-nav-modern btn-next-modern"
            (click)="nextStep()"
          >
            {{ "EDIT_RESERVATION.NEXT" | translate }}
          </button>
          } @if (currentStep === totalSteps) {
          <button
            cButton
            type="submit"
            class="btn-submit-modern"
            [attr.aria-busy]="isLoading"
          >
            <i class="cil-save me-2"></i>
            {{ "EDIT_RESERVATION.SAVE_BUTTON" | translate }}
          </button>
          }
        </div>
      </form>
    </c-card-body>
    <c-card-footer class="powered-sagel text-center">
      <small class="powered-text text-uppercase"
        >{{ "EDIT_RESERVATION.POWERED_BY" | translate }}
        <span class="text-accent fw-semibold">Sagel</span></small
      >
      <img
        src="assets/img/brand/SAGEL_SMALL.svg"
        alt="Sagel logo"
        class="powered-logo ms-2"
      />
    </c-card-footer>
  </c-card>
  } @if (success !== null) {
  <div class="modal-overlay" role="dialog" aria-modal="true">
    <div class="modal-card" [ngClass]="success ? 'success' : 'danger'">
      <div class="modal-status-icon">
        @if (success) {
        <svg [cIcon]="icons.cilCheckCircle" size="xxl"></svg>
        } @if (success === false) {
        <svg [cIcon]="icons.cilXCircle" size="xxl"></svg>
        }
      </div>
      <h3 class="modal-title">
        {{
          success
            ? ("EDIT_RESERVATION.ALERT_SUCCESS_TITLE" | translate)
            : ("EDIT_RESERVATION.ALERT_ERROR_TITLE" | translate)
        }}
      </h3>
      <p class="modal-message">
        {{
          success
            ? ("EDIT_RESERVATION.ALERT_SUCCESS_TEXT" | translate)
            : errorMessage || ("EDIT_RESERVATION.ALERT_ERROR_TEXT" | translate)
        }}
      </p>
      @if (success) {
      <p class="modal-hint">
        {{ "EDIT_RESERVATION.SUCCESS_HINT" | translate }}
      </p>
      } @if (success === false) {
      <button type="button" class="modal-action" (click)="success = null">
        {{ "EDIT_RESERVATION.OK" | translate }}
      </button>
      }
    </div>
  </div>
  } }
</div>
